import React, { useState } from "react";
import "react-quill/dist/quill.snow.css";
import { Modal, Box, Typography, TextField, Button } from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { ApprovalStatuses } from "../../../constants/Status";
import { withTranslation } from "react-i18next";

const CommentModal = ({ handleRejectModal, open, handleApproval, module, t }) => {
  const validate = Yup.object().shape({
    comment: Yup.string()
      .strict(true)
      .trim(t('Must not include leading and trailing spaces'))
      .max(2000, t("Comment can not be greater than 2000 characters"))
      .required(t("Comment is a required")),
  });

  return (
    <React.Fragment>
      <div className="rejectModal">
        <Modal
          open={open}
          onClose={handleRejectModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="rejectPopupButton rejectModalStyle">
            <Typography
              id="modal-modal-title"
              className="rejectPopHeading"
              variant="h6"
              component="h2"
            >
              {t(`Why do you want to reject this ${module}?`)}
            </Typography>
            <Formik
              initialValues={{
                comment: "",
              }}
              validateOnMount
              validationSchema={validate}
              onSubmit={(values) => {
                handleApproval(ApprovalStatuses.REJECTED, values.comment);
              }}
            >
              {({ errors, touched, setFieldValue, handleBlur, isValid }) => (
                <Form>
                  <div>
                    <TextField
                      autoFocus
                      margin="dense"
                      id="comment"
                      label={t("Comment")}
                      fullWidth
                      variant="standard"
                      name="comment"
                      onChange={(event) =>
                        setFieldValue("comment", event.target.value)
                      }
                      onBlur={handleBlur}
                    />
                    <div>
                      {touched.comment && errors.comment ? (
                        <div className="messageErrorStyle">
                          {errors.comment}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="projApprovalbtns mt-4">
                    <Button
                      variant="outlined"
                      className="approveBtn mx-2"
                      type="submit"
                      disabled={!isValid}
                    >
                      {t("Reject")}
                    </Button>
                    <Button
                      disableElevation
                      variant="contained"
                      className="cancelBttn mx-2"
                      type="reset"
                      onClick={handleRejectModal}
                    >
                      {t("Cancel")}
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </Box>
        </Modal>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(CommentModal);
